import { useQuery } from '@tanstack/react-query';
import { fetchAllPatients } from '../services/admin_patients';

const useAllPatients = (pageNumber = 1, pageSize = 10) => {
    const getAllPatients = useQuery({
        queryKey: ['allPatients', pageNumber, pageSize],
        queryFn: () => fetchAllPatients(pageNumber, pageSize)
    });
    return getAllPatients;
}

export default useAllPatients; 